import { render } from "./PostListItem.vue?vue&type=template&id=746312bb"
import script from "./PostListItem.vue?vue&type=script&lang=js"
export * from "./PostListItem.vue?vue&type=script&lang=js"
script.render = render

export default script